var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import { gql, useMutation } from "@apollo/client";
import { entityFieldMutationFragment } from "../utils/entity-field-mutation-fragment";
import { graphql } from "@shapeable/graphql";
export var useEntityMutation = function (_a) {
  var type = _a.type,
    entityTypeName = _a.entityTypeName,
    _b = _a.fields,
    fields = _b === void 0 ? [] : _b;
  var mutationName = "".concat(type.toLowerCase()).concat(entityTypeName);
  var mutationQueryArgs = {
    Update: "$id: ID!, $input: ".concat(entityTypeName, "Input!"),
    Create: "$input: ".concat(entityTypeName, "Input!"),
    Delete: "$id: ID!"
  };
  var mutationArgs = {
    Update: 'id: $id, input: $input',
    Create: 'input: $input',
    Delete: 'id: $id'
  };
  var mutation = graphql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    mutation ", "", "Mutation(", ") {\n      ", "(", ") {\n        id\n        name\n        updated\n        ...EntityOpenGraphFieldsDetails\n        ...EntityViews\n        ", "\n      }\n    }"], ["\n    mutation ", "", "Mutation(", ") {\n      ", "(", ") {\n        id\n        name\n        updated\n        ...EntityOpenGraphFieldsDetails\n        ...EntityViews\n        ", "\n      }\n    }"])), entityTypeName, type, mutationQueryArgs[type], mutationName, mutationArgs[type], fields.map(function (fieldDefn) {
    return entityFieldMutationFragment(fieldDefn);
  }).join('\n'));
  var _c = __read(useMutation(gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", ""], ["", ""])), mutation)), 2),
    submit = _c[0],
    _d = _c[1],
    data = _d.data,
    loading = _d.loading,
    error = _d.error;
  return {
    result: data === null || data === void 0 ? void 0 : data[mutationName],
    submit: submit,
    loading: loading,
    mutation: mutation,
    error: error
  };
};
var templateObject_1, templateObject_2;